import reducer from './reducer';
import { MODULE_NAME } from './constants';

export {
    setActiveCategory,
    enableAutoUpdateMenuCategory,
    fetchMenuPositionDetails,
    enableAutoUpdateMenu
} from './actions';

export {
    selectMenus,
    selectCategories,
    selectActiveCategoryId,
    selectIsCategoryAutoUpdateDisabled,
    selectActiveMenuId,
    selectMultipleMenus,
    selectIsMenuAutoUpdateDisabled,
    selectScrollToCategoryIndex,
    selectFlatMenu
} from './selectors';

export default {
    reducer,
    moduleName: MODULE_NAME
};
